import type { PreisToolItem } from '@/api/preis-tool/preis-tool.types';
import { DsButton, DsModal } from '@/modules/internal-v2/ds';
import { PriceHistory } from './price-history.component';

interface PriceHistoryDialogProps {
  article: PreisToolItem;
  onClose: () => void;
}

/** Price history of the selected item as a dialog, opened from the workspace header (EOS-54). */
export function PriceHistoryDialog({ article, onClose }: PriceHistoryDialogProps) {
  return (
    <DsModal
      open
      onClose={onClose}
      size="wide"
      title={`Preisverlauf · ${article.id}`}
      description={article.name}
      footer={<DsButton onClick={onClose}>Schließen</DsButton>}
    >
      <PriceHistory itemId={article.id} />
    </DsModal>
  );
}
